import './external.scss';
import './index.scss';

console.log(
  '%c timaskey.com ',
  'color: #fff; background-color: #fa0; font-weight: 700;'
);

document.querySelectorAll('.single-project__floorplans').forEach((el) => {
  const slides = el.querySelectorAll('.single-project__floorplan');
  const prev = el.querySelector('.button--prev');
  const next = el.querySelector('.button--next');
  let index = 0;

  function setIndex(newIndex) {
    index = newIndex;
    slides.forEach((slide, i) => {
      if (i === index) {
        slide.classList.add('active');
      } else {
        slide.classList.remove('active');
      }
    });
  }

  if (prev) {
    prev.addEventListener('click', () => {
      setIndex(index === 0 ? slides.length - 1 : index - 1);
    });
  }

  if (next) {
    next.addEventListener('click', () => {
      setIndex((index + 1) % slides.length);
    });
  }

  setIndex(0);
});

document.querySelectorAll('.home-slideshow').forEach((el) => {
  const slides = el.querySelectorAll('.home-slideshow__slide');
  const dots = el.querySelectorAll('.home-slideshow__dot');
  let index = 0;
  let timer;

  function setIndex(newIndex) {
    index = newIndex;
    slides.forEach((slide, i) => {
      if (i === index) {
        slide.classList.add('active');
        dots[i].classList.add('active');
      } else {
        slide.classList.remove('active');
        dots[i].classList.remove('active');
      }
    });

    window.clearTimeout(timer);
    timer = window.setTimeout(() => {
      setIndex((index + 1) % slides.length);
    }, 5000);
  }

  dots.forEach((dot, i) => {
    dot.addEventListener('click', () => {
      setIndex(i);
    });
  });

  setIndex(0);
});

document.querySelector('#header-menu-toggle').addEventListener('click', () => {
  document.body.classList.toggle('menu-active');
});
